import { createSlice } from '@reduxjs/toolkit';

export const pizzaSlice = createSlice({
    name: 'pizza',
    initialState: {
        items: [],
        isLoading: true,
    },
    reducers: {
        setItems: (state, action) => {
            state.items = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    }
});

export const { setItems, setIsLoading } = pizzaSlice.actions;

export default pizzaSlice.reducer;
